export function estimateReadingTime(summary?: string): number {
  if (!summary) return 3;
  const words = summary.trim().split(/\s+/).length;
  return Math.max(3, Math.ceil(words / 8));
}
